import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const HomePage = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

             // Redirect authenticated users directly to the partner portal
           React.useEffect(() => {
             if (isAuthenticated) {
               navigate('/signin');
             }
           }, [isAuthenticated, navigate]);

     const handlePartnerPortalClick = () => {
     if (isAuthenticated) {
       navigate('/portal');
     } else {
       navigate('/signin');
     }
   };

  const handleExpressionOfInterestClick = () => {
    navigate('/expression-of-interest');
  };

  const handleDirectoryClick = () => {
    navigate('/directory');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100 flex items-center justify-center relative">
      {/* Background watermark */}
      <div 
        className="absolute bg-no-repeat bg-contain opacity-40"
        style={{
          backgroundImage: 'url(/PH-Icon-White.png)',
          height: '50vh',
          width: '50vh',
          bottom: '5%',
          left: '5%',
        }}
      ></div>
      
      {/* Content overlay */}
      <div className="relative z-10">
        <div className="max-w-4xl mx-auto text-center px-6">
          {/* Logo */}
          <div className="mb-12">
            <img 
              src="/ProductHub-Logo-Stacked.png" 
              alt="ProductHub Logo" 
              className="mx-auto max-w-md w-full h-auto rounded-2xl shadow-2xl"
            />
          </div>

          {/* Welcome Content */}
          <div className="mb-12">
            <h1 className="text-5xl font-bold mb-6" style={{ color: 'var(--ph-main-blue)' }}>
              ProductHub Alliance Portal
            </h1>
            <p className="text-2xl text-gray-600 mb-4">
              Your comprehensive directory of supply chain and industry professionals, companies, and GS1 offices
            </p>
            <p className="text-xl text-gray-500 mb-6">
              Everything you need to produce, market, store, distribute or transport in the supply chain and associated industries
            </p>
            
            {/* Key Benefits */}
            <div className="grid md:grid-cols-3 gap-6 mb-8">
              <div className="bg-white p-6 rounded-lg shadow-lg">
                <div className="text-3xl mb-2">🏢</div>
                <h3 className="text-lg font-semibold mb-2">Partner Network</h3>
                <p className="text-gray-600">Connect with verified professionals across all sectors</p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-lg">
                <div className="text-3xl mb-2">📚</div>
                <h3 className="text-lg font-semibold mb-2">Training & Certification</h3>
                <p className="text-gray-600">GS1 US University + internal onboarding process</p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-lg">
                <div className="text-3xl mb-2">💰</div>
                <h3 className="text-lg font-semibold mb-2">Revenue Incentives</h3>
                <p className="text-gray-600">Commission structure and discount programs</p>
              </div>
            </div>
          </div>

          {/* Call to Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <button
              onClick={handleExpressionOfInterestClick}
              className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-4 px-8 rounded-lg text-lg transition-colors duration-200 shadow-lg hover:shadow-xl"
            >
              Express Interest in Partnership
            </button>
            <button
              onClick={handleDirectoryClick}
              className="bg-green-600 hover:bg-green-700 text-white font-semibold py-4 px-8 rounded-lg text-lg transition-colors duration-200 shadow-lg hover:shadow-xl"
            >
              Browse Partner Directory
            </button>
          </div>

          {/* Partner Portal Access */}
          <div className="mb-8">
            <button
              onClick={handlePartnerPortalClick}
              className="bg-gray-800 hover:bg-gray-900 text-white font-semibold py-3 px-6 rounded-lg text-base transition-colors duration-200 shadow-lg hover:shadow-xl"
            >
                               {isAuthenticated ? 'Access Partner Portal' : 'Partner Sign In'}
            </button>
          </div>

          {/* Footer Note */}
          <div className="text-sm text-gray-400">
            <p>For ProductHub Alliance Partners & Potential Partners</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;